// Registro del service worker de la PWA, gateado por el <link rel="manifest"
// data-service-worker="true"> que el layout solo renderiza para partners/staff. El
// manifest de consumidor (Chrome Android, sin ese atributo) no registra nada: solo sirve
// para el banner nativo hacia Play. Sin link marcado se desregistra lo que hubiera
// quedado de la PWA anterior. Ver _docs/frontend/pwa.md
const syncServiceWorker = () => {
  if (!("serviceWorker" in navigator)) return

  const pwaEnabled = Boolean(document.querySelector('link[rel="manifest"][data-service-worker="true"]'))

  if (pwaEnabled) {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {})
    return
  }

  navigator.serviceWorker.getRegistrations()
    .then((registrations) => registrations.forEach((registration) => registration.unregister()))
    .catch(() => {})
}

document.addEventListener("turbo:load", syncServiceWorker)
